import {
  Button,
  FileUploader,
  Form,
  Popup,
  ScrollView,
  TextBox,
} from 'devextreme-react';
import { GroupItem, SimpleItem } from 'devextreme-react/form';
import React from 'react';
import CorpListExcelRegisterListPopupContainer from './corp-list-excel-register-list-popup-container';
import { Link } from 'react-router-dom';

const CorpListExcelRegisterFilePopup = ({
  onHiding,
  onClickInsertFile,
  onValueChangedUploadFile,
  setFileInfo,
  fileInfo,
  visibleExcelRegisterFilePopup,
}) => {
  return (
    <React.Fragment>
      <Popup
        className="popup"
        title="법인 사용자 등록(EXCEL)"
        visible={visibleExcelRegisterFilePopup}
        onHiding={onHiding}
        // width={500}
        // height="90vh"
      >
        <ScrollView showScrollbar="never">
          <div className="corp-list-excel-register-file-content popup-content">
            <div className="font-weight-bold">법인 사용자 등록</div>
            <FileUploader
              accept={'.xls,.xlsx'}
              allowedFileExtensions={['.xls', 'xlsx']}
              labelText={
                fileInfo && fileInfo.length > 0 ? fileInfo[0].name : ''
              }
              selectButtonText="파일선택"
              showFileList={false}
              uploadMode="useForm"
              visible={true}
              value={fileInfo}
              onValueChanged={onValueChangedUploadFile}
            />
            <div className="attention">
              기본양식을 다운로드 후 양식에 맞게 등록해주세요.
            </div>
          </div>
          <div className="corp-list-excel-register-file-bottom">
            <Link to="/Sample.xlsx" target="_blank" download>
              <Button
                stylingMode="contained"
                type="success"
                text="기본양식다운로드"
              />
            </Link>
            <Button
              stylingMode="contained"
              type="default"
              text="등록확인"
              onClick={onClickInsertFile}
            />
            <Button
              stylingMode="contained"
              type="normal"
              text="닫기"
              onClick={onHiding}
            />
          </div>
        </ScrollView>
      </Popup>
      <CorpListExcelRegisterListPopupContainer setFileInfo={setFileInfo} />
    </React.Fragment>
  );
};

export default React.memo(CorpListExcelRegisterFilePopup);
